import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import AddCategory from "../components/category/AddCategory";

import Title from "../components/header/Title";

const CreateCategory: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEditMode = Number(id) > 0;

  return (
    <React.Fragment>
      <Title
        title={isEditMode ? "Edit Category" : "Add New Category"}
        subtitle={
          isEditMode
            ? "Update this Product Category"
            : "Create a New Product Category"
        }
        onBack={() => navigate("/categories")}
      />
      <AddCategory />
    </React.Fragment>
  );
};

export default CreateCategory;
